function brokerbayMobileSetHeightController($timeout) {
  this.$onInit = () => {
    // Using timeout here to update a height after rendering
    $timeout(() => {
      if (this.setHeight) this.setHeight();
    });
  };

  this.$onChanges = () => {
    // Using timeout here to update a height after rendering
    $timeout(() => {
      if (this.setHeight) this.setHeight();
    });
  };
}

brokerbayMobileSetHeightController.$inject = ['$timeout'];

function brokerbayMobileSetHeight($window) {
  return {
    restrict: 'A',
    scope: {
      brokerbayMobileSetHeightTrigger: '<*',
    },
    bindToController: true,
    require: '^brokerbayMobileSetHeight',
    controller: brokerbayMobileSetHeightController,
    link: (scope, elem, attr, ctrl) => {
      if ($window.screen.width <= 767) {
        // In safari, overflow: scroll with `height: 100%` is not working properly.
        // Thererfore, it sets a height based on the position of #mobile-buttons element to make a scroll to work on safari.
        ctrl.setHeight = () => {
          const correctHeight =
            angular.element('#mobile-buttons').offset().top - elem.offset().top;
          elem.css('height', `${correctHeight}px`);
        };
      }
    },
  };
}

brokerbayMobileSetHeight.$inject = ['$window'];

export default brokerbayMobileSetHeight;
